import React from 'react'
import { css } from 'styled-components'
import { Grid as GridBase, styled } from '@mui/material'
import { Button as ButtonBase } from '@chilecompra/react-kit/components'

export const GridContainer = styled(({ enableBorder, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    ${props =>
      !props.enableBorder
        ? ''
        : css`
            border: 1px solid rgba(46, 91, 255, 0.08);
            border-radius: 1px;
          `}
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  margin: 0;
`

export const Subtitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
`

export const HeadTitle = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
`

export const BodyParagraph = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 21px;
  margin: 0;
  font-weight: 400;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const BodyLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  letter-spacing: 0;
  line-height: 16px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
export const Image = styled('img')`
  width: 50%;
`
export const Root = styled('div')`
  width: 100%;
`
